export const ORGANIZATION_KEY = 'organization';
export const TERM_KEY = `${ORGANIZATION_KEY}.term`;
export const MODULE_KEY = 'module';
export const INITIAL_PAGE_KEY = 'initial-page';
